import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './VendorDetails.css';
import api from '../../api/axios.js'
import { API_IMAGE_BASE_URL } from '../../config/api';
import { FiEdit } from 'react-icons/fi';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const VendorDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [enquirySearch, setEnquirySearch] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
   const [loading, setLoading] = useState(true)
  const [blockActionLoading, setBlockActionLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
 const [editUserForm, setEditUserForm] = useState({
  name: "",
  email: "",
  mobile_number: "",
  gender: "",
  shop_name: "",
  shop_email: "",
  about: "",
  address: "",
  city: "",
});
  const [editForm, setEditForm] = useState({
    vendorName: '',
    email: '',
    phone: '',
    gender: '',
    services: '',
    coins: '',
    shopName: '',
    shopPhone: '',
    shopEmail: '',
    about: '',
    aadhar:'',
    gst:'',
    pan:'',
    trade_license: '',
    company_logo: '',
    banner_image: '',
    address: '',
    city: '',
    gallery:[],
    videos:[],
    status: '' ,
    dateOfJoining: ''
  })

  const [subscription, setSubscription] = useState(null)

  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const handlePreview = (url) => {
    if (!url) return;
    setPreviewImageUrl(url);
    setShowPreviewModal(true);
  }

   useEffect(() => {
    fetchVendorDetails();
    fetchCurrentSubscription()
  }, [id]); 

  const fetchVendorDetails = async () => { 
    try {
      setLoading(true);
      const res = await api.get(`/listing/vendor-details/${id}`);
      console.log(res,"resssd")

      const user = res?.data?.data?.user
      console.log("Profile Image:", user?.profile_image);

console.log("Gallery Images:", user?.gallery_image);
      const categories = res?.data?.data?.categories?.data || []; 

  setEditForm({
  vendorName: user?.name || '',
  email: user?.email || '',
  phone: user?.mobile_number || '',
  gender: user?.gender || '',
  services: categories.map(cat => cat.title).join(', '),
  coins: user?.coins || 0,
  shopName: user?.shop_name || '',
  shopPhone: user?.mobile_number || '',
  shopEmail: user?.shop_email || '',
  about: user?.about || '',
  aadhar: user?.adhaar_card_certificate || '',
  gst: user?.gst_certificate || '',
  pan: user?.pan_card_certificate || '',
  trade_license: user?.trade_license || '',
  company_logo: user?.company_logo || '',
  banner_image: user?.banner_image || '',
  address: user?.address || '',
  city: user?.city || '',
  dateOfJoining: user?.date_of_joining || '',
  status: user?.status || '',
  roles: user?.roles || [],
  vendorProfileCompletion: user?.vendorProfileCompletion || 0,
  gallery: user?.gallery_image?.map(img => ({
    id: img._id,
    url: img.url,
    status: img.status || (img.isApproved ? 'approved' : 'rejected'),
    rejectionReason: img.rejectionReason || null
  })) || [],
  videos: user?.videos?.map(video => ({
    id: video._id,
    url: video.url,
    status: video.status || (video.isApproved ? 'approved' : 'rejected'),
    rejectionReason: video.rejectionReason || null
  })) || []
      });
    } catch (err) {
      console.error('Error fetching vendor details', err);
    } finally {
      setLoading(false);
    }
  };

 const handleMediaStatusChange = async (type, index, status) => {
  try {
    const media = type === 'gallery_image' ? editForm.gallery[index] : editForm.videos[index];

    let reason = null;
    if (status === 'rejected') {
      reason = window.prompt('Reason for rejecting this media:', media.rejectionReason || '') || 'Rejected by admin';
    }

    await api.patch('/admin/users/media-status', {
      vendorId: id,
      mediaId: media.id,
      mediaType: type,
      status,
      reason,
    });

    // Update local state
    const updatedForm = { ...editForm };
    const list = type === 'gallery_image' ? updatedForm.gallery : updatedForm.videos;
    list[index].status = status;
    list[index].rejectionReason = status === 'rejected' ? reason : null;

    setEditForm(updatedForm);
  } catch (err) {
    console.error('Media status update failed', err);
  }
};




const fetchCurrentSubscription = async () => {
  try {
    const res = await api.get(`/admin/current/${id}`);

    // if success & data exists
    setSubscription(res?.data?.data || null);
    console.log(res.data?.data,"res")
  } catch (err) {
    console.error('Error fetching current subscription', err);
    setSubscription(null);
  }
}

  const handleBack = () => {
    navigate('/user-management');
  };

  const handleEdit = () => {
    setFormErrors({});
    setEditUserForm({
  name: editForm.vendorName || "",
  email: editForm.email || "",
  mobile_number: editForm.phone || "",
  gender: editForm.gender || "",
  shop_name: editForm.shopName || "",
  shop_email: editForm.shopEmail || "",
  about: editForm.about || "",
  address: editForm.address || "",
  city: editForm.city || "",
});
    setShowEditModal(true);
  }

  const isVendorBlocked = ["inactive", "blocked"].includes(
    (editForm?.status || "").toLowerCase()
  );

  const handleToggleBlockStatus = async () => {
    try {
      setBlockActionLoading(true);
      if (isVendorBlocked) {
        await api.put(`/admin/reactivate/user/${id}`);
        toast.success("Vendor unblocked successfully");
      } else {
        await api.put(`/admin/soft-delete/user/${id}`, {
          reason: "inactive",
        });
        toast.success("Vendor blocked successfully");
      }
      await fetchVendorDetails();
    } catch (err) {
      console.error("Block/unblock failed", err);
      toast.error(err?.response?.data?.message || "Block/unblock failed");
    } finally {
      setBlockActionLoading(false);
    }
  };

 const handleSave = async () => {
  const errors = {};

  // Strict Regex
  const nameRegex = /^[A-Za-z ]{2,60}$/;
  const emailRegex =
    /^[a-z0-9._%+-]{2,60}@[a-z0-9.-]+\.[a-z]{2,}$/;
  const mobileRegex = /^\d{10,12}$/;

  // Name Validation
  const trimmedName = editUserForm.name?.trim();

  if (!trimmedName) {
    errors.name = "Name is required";
  } else if (trimmedName.length < 2 || trimmedName.length > 60) {
    errors.name = "Name must be between 2 and 60 characters";
  } else if (!nameRegex.test(trimmedName)) {
    errors.name =
      "Name can contain only alphabets and spaces";
  }

  // Email Validation
  const trimmedEmail = editUserForm.email
    ?.trim()
    .toLowerCase();

  if (!trimmedEmail) {
    errors.email = "Email is required";
  } else if (
    trimmedEmail.length < 2 ||
    trimmedEmail.length > 60
  ) {
    errors.email = "Email must be between 2 and 60 characters";
  } else if (!emailRegex.test(trimmedEmail)) {
    errors.email = "Enter a valid email address";
  }

  // Mobile Validation
  const trimmedMobile = editUserForm.mobile_number?.trim();

  if (!trimmedMobile) {
    errors.mobile_number = "Mobile number is required";
  } else if (!mobileRegex.test(trimmedMobile)) {
    errors.mobile_number =
      "Mobile number must contain 10 to 12 digits";
  }

  if (Object.keys(errors).length > 0) {
    setFormErrors(errors);
    return;
  }

  try {
    await api.put(`/admin/update/user/${id}`, {
      name: trimmedName
        .split(" ")
        .filter(Boolean)
        .map(
          word =>
            word.charAt(0).toUpperCase() +
            word.slice(1).toLowerCase()
        )
        .join(" "),

      email: trimmedEmail,

      mobile_number: trimmedMobile,

      ...(editUserForm.gender && { gender: editUserForm.gender }),
      ...(editUserForm.shop_name !== undefined && { shop_name: editUserForm.shop_name }),
      ...(editUserForm.shop_email !== undefined && { shop_email: editUserForm.shop_email }),
      ...(editUserForm.about !== undefined && { about: editUserForm.about }),
      ...(editUserForm.address !== undefined && { address: editUserForm.address }),
      ...(editUserForm.city !== undefined && { city: editUserForm.city }),
    });

    toast.success("Vendor updated successfully");
    setFormErrors({});
    setShowEditModal(false);
    fetchVendorDetails();
  } catch (err) {
    console.error("Error updating vendor", err);

    if (err?.response?.status === 409) {
      setFormErrors({ email: "Email already exists" });
      return;
    }

    toast.error(
      err?.response?.data?.message ||
        "Failed to update vendor"
    );
  }
};

  if (loading) {
    return <div className="vendor-details">Loading...</div>; 
  }

  return (
    <div className="vendor-details">
      <div className="details-header">
        <button className="back-btn" onClick={handleBack}>← Back</button>
        <div className="header-actions">
          <h1>👤Vendor Details</h1>
          <button className="edit-btn" onClick={handleEdit}><FiEdit /> Edit</button>
          <button
            className="edit-btn"
            onClick={handleToggleBlockStatus}
            disabled={blockActionLoading}
          >
            {blockActionLoading
              ? "Please wait..."
              : isVendorBlocked
              ? "Unblock Vendor"
              : "Block Vendor"}
          </button>
          {/* <button className="edit-btn" onClick={handleEdit}><FiEdit /></button> */}
        </div>
      </div>

      <div className="vendor-info">
        <div className="info-section">
          <div className="info-grid2">
  <div className="info-item2 name-item">
    <span className="label">Name</span>
<span className="value">
  {editForm.vendorName
    ? editForm.vendorName
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : ''}
</span>
  </div>

 <div className="info-item2 email-item">
  <span className="label">Email</span>
  <span className="value">
    {editForm.email?.trim() || 'N/A'}
  </span>
</div>

<div className="info-item2 phone-item">
  <span className="label">Phone</span>
  <span className="value">
    {editForm.phone?.trim() || 'N/A'}
  </span>
</div>


<div className="info-item2 gender-item">
  <span className="label">Gender</span>
  <span className="value">
    {editForm.gender?.trim() || 'N/A'}
  </span>
  {/* <div className="info-item2 doj-item">
  <span className="label">Date of Joining</span>
  <span className="value">
    {editForm?.dateOfJoining
      ? new Date(editForm.dateOfJoining).toLocaleDateString('en-IN')
      : 'N/A'}
  </span>
</div> */}




</div>




 <div className="info-item2 services-item">
    <span className="label">Services</span>
    <span className="value">
    {editForm.services?.trim() || 'No service added yet'}
    </span>   
</div>


<div className="info-item2 doj-item">
  <span className="label">Date of Joining</span>
  <span className="value">
    {editForm?.dateOfJoining
      ? new Date(editForm.dateOfJoining).toLocaleDateString('en-IN')
      : 'N/A'}
  </span>
</div>
<div className="info-item2 role-item">
  <span className="label">Roles</span>
  <span className="value">
    {editForm?.roles?.length
      ? editForm.roles
          .map(role =>
            `${role.userType} (${role.priority})`
          )
          .join(', ')
      : 'N/A'}
  </span>
</div>

<div className="info-item2 status-item">
    <span className="label">Status</span>
    <span className={`value status-badge ${editForm.status}`}>
      {editForm.status ? editForm.status.charAt(0).toUpperCase() + editForm.status.slice(1) : 'N/A'}
    </span>
  </div>
  <div className="profile-completion">
  <div className="label">
    Profile Completion: {editForm.vendorProfileCompletion}%
  </div>

  <div className="progress-bar">
    <div
      className="progress-fill"
      style={{ width: `${editForm.vendorProfileCompletion}%` }}
    />
  </div>
</div>

</div>


          
        </div>


        

        <div className="business-section">
  <h3>Shop/Business Information</h3>

  <div className="business-grid">
     <div className="business-item">
    <span className="label">Shop Name</span>
    <span className="value">
      {editForm?.shopName?.trim() || 'N/A'}
    </span>
  </div>


    <div className="business-item">
      <span className="label">Shop Email</span>
       <span className="value">
      {editForm?.shopEmail?.trim() || 'N/A'}
    </span>
    </div>
  </div>

  <div className="business-grid">
    <div className="business-item">
      <span className="label">Aadhar Card</span>
      {editForm?.aadhar ? (
        <a
          href={`${API_IMAGE_BASE_URL}${editForm.aadhar}`}
          target="_blank"
          rel="noopener noreferrer"
          className="value business-link"
        >
          View PDF
        </a>
      ) : (
        <span className="value">Not Uploaded</span>
      )}
    </div>

    <div className="business-item">
      <span className="label">GST CERTIFICATE</span>
      {editForm?.gst ? (
        <a
          href={`${API_IMAGE_BASE_URL}${editForm.gst}`}
          target="_blank"
          rel="noopener noreferrer"
          className="business-link"
        >
          View PDF
        </a>
      ) : (
        <span className="value">Not Uploaded</span>
      )}
    </div>

    <div className="business-item">
      <span className="label">PAN CARD</span>
      {editForm?.pan ? (
        <a
          href={`${API_IMAGE_BASE_URL}${editForm.pan}`}
          target="_blank"
          rel="noopener noreferrer"
          className="business-link"
        >
          View PDF
        </a>
      ) : (
        <span className="value">Not Uploaded</span>
      )}
    </div>

    <div className="business-item">
      <span className="label">Trade License</span>
      {editForm?.trade_license ? (
        <a
          href={`${API_IMAGE_BASE_URL}${editForm.trade_license}`}
          target="_blank"
          rel="noopener noreferrer"
          className="business-link"
        >
          View PDF
        </a>
      ) : (
        <span className="value">Not Uploaded (Optional)</span>
      )}
    </div>
  </div>

  <div className="business-grid">
    <div className="business-item">
      <span className="label">Address</span>
      <span className="value">{editForm?.address?.trim() || 'N/A'}</span>
    </div>
    <div className="business-item">
      <span className="label">City</span>
      <span className="value">{editForm?.city?.trim() || 'N/A'}</span>
    </div>
  </div>

  <div className="business-grid">
      <div className="business-item">
        <span className="label">Company Logo</span>
        {editForm?.company_logo ? (
          <img
            src={`${API_IMAGE_BASE_URL}${editForm.company_logo}`}
            alt="Company Logo"
            onClick={() => handlePreview(`${API_IMAGE_BASE_URL}${editForm.company_logo}`)}
            style={{ maxHeight: 48, maxWidth: 160, height: 'auto', width: 'auto', borderRadius: 4, objectFit: 'contain', cursor: 'pointer' }}
          />
        ) : (
          <span className="value">Not Uploaded</span>
        )}
      </div>
    <div className="business-item">
      <span className="label">Banner Image</span>
      {editForm?.banner_image ? (
        <img
          src={`${API_IMAGE_BASE_URL}${editForm.banner_image}`}
          alt="Banner"
          onClick={() => handlePreview(`${API_IMAGE_BASE_URL}${editForm.banner_image}`)}
          style={{ maxHeight: 48, maxWidth: '100%', height: 'auto', borderRadius: 4, objectFit: 'contain', cursor: 'pointer' }}
        />
      ) : (
        <span className="value">Not Uploaded</span>
      )}
    </div>
  </div>
</div>

      {showPreviewModal && (
        <div
          className="image-preview-overlay"
          onClick={() => setShowPreviewModal(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <div style={{ maxWidth: '95%', maxHeight: '95%' }} onClick={(e) => e.stopPropagation()}>
            <img src={previewImageUrl} alt="Preview" style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: 6 }} />
          </div>
        </div>
      )}


        <div className="info-section">
          <h3>Portfolio & About</h3>
          <div className="portfolio-images">
  <h4>Images</h4>
{editForm?.gallery?.length > 0 ? (
  editForm.gallery.map((img, index) => {
    console.log(
      "Image URL:",
      `${API_IMAGE_BASE_URL}${img.url}`
    );

    return (
      <div className="portfolio-item" key={index}>
        <img
          src={`${API_IMAGE_BASE_URL}${img.url}`}
          alt={`portfolio-${index}`}
          onLoad={() => console.log("IMAGE LOADED")}
          onError={() => console.log("IMAGE FAILED")}
        />

        <div className="media-status-bar">
          <label>Status:</label>

          <select
            className="select-status-media"
            value={img.status}
            onChange={(e) =>
              handleMediaStatusChange(
                "gallery_image",
                index,
                e.target.value
              )
            }
          >
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
          </select>
          {img.status === 'rejected' && img.rejectionReason && (
            <p className="rejection-reason">Reason: {img.rejectionReason}</p>
          )}
        </div>
      </div>
    );
  })
) : (
  <p className="no-data">No portfolio images</p>
)}

  <h4>Videos</h4>
  {editForm?.videos?.length > 0 ? (
    editForm.videos.map((video, index) => (
      <div className="portfolio-item" key={`vid-${index}`}>
        <video
          className="portfolio-video"
          src={`${API_IMAGE_BASE_URL}${video.url}`}
          controls
          width="100%"
        />
        <div className="media-status-bar">
          <label>Status:</label>
          <select
  value={video.status}
  onChange={(e) => handleMediaStatusChange('videos', index, e.target.value)}
  className='select-status-media'
>
  <option value="pending">Pending</option>
  <option value="approved">Approved</option>
  <option className='med-rej' value="rejected">Rejected</option>
</select>
          {video.status === 'rejected' && video.rejectionReason && (
            <p className="rejection-reason">Reason: {video.rejectionReason}</p>
          )}
        </div>
      </div>
    ))
  ) : (
    <p className="no-data">No Videos added</p>
  )}
</div>

<div className="about-section">
  <h4>About</h4>
  <p>
    {editForm?.about?.trim() || 'No description added yet'}
  </p>
</div>
        </div>

       
        <div className="info-section">
  <h3>Subscription Purchased</h3>

  {subscription && subscription.isActive ? (
    <div className="subscription-table">
      <div className="table-header">
        <span>Subscription</span>
        <span>Purchased Date</span>
        <span>Valid till</span>
        <span>Amount</span>
        <span>Status</span>
      </div>

      <div className="table-row">
        <span>{subscription.planId?.name}</span>

        <span>
          {new Date(subscription.startDate).toLocaleDateString()}
        </span>

        <span>
          {new Date(subscription.endDate).toLocaleDateString()}
        </span>
        <span>
          ₹{subscription?.amountPaid}
        </span>

        <span className="status active">Active</span>
      </div>
    </div>
  ) : (
    <p className="no-data">No active subscription</p>
  )}
</div>


       
      </div>

      {/* Edit Modal */}
      {showEditModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Edit Vendor</h2>
            <input
              placeholder="Name"
              value={editUserForm.name || ""}
              onChange={(e) => setEditUserForm({ ...editUserForm, name: e.target.value })}
            />
            {formErrors.name && <span className="form-error">{formErrors.name}</span>}

            <input
              placeholder="Email"
              value={editUserForm.email || ""}
              onChange={(e) => setEditUserForm({ ...editUserForm, email: e.target.value })}
            />
            {formErrors.email && <span className="form-error">{formErrors.email}</span>}

            <input
              placeholder="Mobile"
              value={editUserForm.mobile_number || ""}
              onChange={(e) => setEditUserForm({ ...editUserForm, mobile_number: e.target.value })}
            />
            {formErrors.mobile_number && (
              <span className="form-error">{formErrors.mobile_number}</span>
            )}
            <select
  value={editUserForm.gender || ""}
  onChange={(e) =>
    setEditUserForm({
      ...editUserForm,
      gender: e.target.value,
    })
  }
>
  <option value="">Select Gender</option>
  <option value="Male">Male</option>
  <option value="Female">Female</option>
  <option value="Other">Other</option>
</select>

<input
  placeholder="Shop Name"
  value={editUserForm.shop_name || ""}
  onChange={(e) =>
    setEditUserForm({
      ...editUserForm,
      shop_name: e.target.value,
    })
  }
/>

<input
  placeholder="Shop Email"
  value={editUserForm.shop_email || ""}
  onChange={(e) =>
    setEditUserForm({
      ...editUserForm,
      shop_email: e.target.value,
    })
  }
/>

<textarea
  placeholder="About"
  rows={4}
  value={editUserForm.about || ""}
  onChange={(e) =>
    setEditUserForm({
      ...editUserForm,
      about: e.target.value,
    })
  }
/>

<input
  placeholder="Address"
  value={editUserForm.address || ""}
  onChange={(e) =>
    setEditUserForm({
      ...editUserForm,
      address: e.target.value,
    })
  }
/>

<input
  placeholder="City"
  value={editUserForm.city || ""}
  onChange={(e) =>
    setEditUserForm({
      ...editUserForm,
      city: e.target.value,
    })
  }
/>

            <div className="form-actions">
              <button type="button" onClick={() => setShowEditModal(false)}>
                Cancel
              </button>
              <button type="button" onClick={handleSave}>
                Update
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer
        toastClassName="custom-toast"
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default VendorDetails;